import {
  DATA_TO_LIST,
  DETAILS_DATA_TO_LIST,
  DATA_TO_CHANGE,
  CLEAR_STATE,
  LOADING,
  PAGINATION,
  FILTER,
  SEARCH,
} from './types';

import { getUserId, getUserCountry, getToken } from './userData';

import Request from 'plugin-tigre-request';
import utils from '@/utils';
import {getCustomerId} from './userData';

export default (resorcePath, detailsListKey, customRequestFn) => {
  const requestDataFn = customRequestFn;
  const resource = resorcePath;
  const defaultRequestParam = (
    resource2 = resource,
    requestDataFn2 = requestDataFn
  ) => {
    let request = requestDataFn2 || utils.makeDefaultRequestData();
    return {
      ...request,
      resource: `${resource2}`,
    };
  };

  const PromiseReturn = (method, path, data) => {
    let requestParam = {
      ...defaultRequestParam(),
      data,
      method,
      path,
    };
    return new Promise((resolve, reject) => {
      Request(requestParam)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    store: {
      namespaced: true,
      state: {
        list: [],
        details: [],
        data: {},
        loading: false,
        filters: {},
        status:[],
        search: '',
      },
      getters: {
        getList(state) {
          return state.list;
        },
        getDetailsList(state) {
          return state.details;
        },
        getData(state) {
          return state.data;
        },
        getLoading(state) {
          return state.loading;
        },
        getFilters(state) {
          return state.filters;
        },
        getStatus(state) {
          return state.status;
        },
        getListFilter(state) {
          let list = state.list;
          const keys = Object.keys(state.filters);

          keys.forEach((key) => {
            list = list.filter((item) =>
              state.filters[key] != null
                ? item[key].includes(state.filters[key])
                : item
            );
          });
          return list;
        },
        getSearch(state) {
          return state.search;
        },
      },
      mutations: {
        setDataToList(state, payload) {
          const { data } = payload;
          state.list = data;
        },
        setDetailsDataToList(state, payload) {
          const { data } = payload;
          state.data = data || {};
          state.details = data.ITENS || [];
        },
        setData(state, payload) {
          const { data } = payload;
          state.data = data;
        },
        clearState(state) {
          state.list = [];
          state.details = [];
          state.data = {};
          state.loading = false;
          state.filters = {};
          state.search = '';
        },
        setLoading(state, payload) {
          state.loading = payload;
        },
        setFilter(state, payload) {
          state.filters = {
            ...payload,
          };
        },
        setStatusData(state, payload) {
          const { data } = payload;
          var result = Object.entries(data).map(([key, status]) => ({key,status}));
          state.status = result;
          
        },
        setSearch(state, payload) {
          state.search = payload;
        },
      },
      actions: {
        setPagination({ commit }, data) {
          commit(PAGINATION, data);
        },
        setFilter({ commit }, data) {
          commit(FILTER, data);
        },
        setSearch({ commit }, data) {
          commit(SEARCH, data);
        },
        setAddData(_, data) {
          return PromiseReturn('POST', '', data);
        },
        setUpdateData(_, data) {
          let id = data.id;
          delete data.id;
          return PromiseReturn('PUT', `/${id}`, data);
        },
        setDeleteData(_, data) {
          return PromiseReturn('DELETE', `/${data.id}`);
        },
        setData({ commit }, data) {
          let requestParam = {
            ...defaultRequestParam(),
            method: 'GET',
            data: { USERID: getUserId(), ...getUserCountry(), CUSTOMER: getCustomerId(), FISCAL_CODE: getCustomerId(), TOKEN: getToken() },
            path: `/${data.id}`,
          };
          return new Promise((resolve, reject) => {
            Request(requestParam)
              .then((response) => {
                commit(DATA_TO_CHANGE, {
                  data: response.data.data,
                  request: requestParam,
                });
                resolve(response);
              })
              .catch((error) => {
                reject(error);
              });
          });
        },
        async setDataToList({ commit }, data) {
          let requestParam = {
            ...defaultRequestParam(),
            data: {
              ...data,
              USERID: getUserId(),
              ...getUserCountry(), FISCAL_CODE: getCustomerId(), TOKEN: getToken()
            },
            method: 'GET',
          };
          commit(LOADING, true);
          return new Promise((resolve, reject) => {
            Request(requestParam)
              .then((response) => {
                commit(DATA_TO_LIST, {
                  data: response.data.lista,
                  count: response.data.count,
                  request: requestParam,
                });
                commit(LOADING, false);
                resolve(response);
              })
              .catch((error) => {
                reject(error);
              });
          });
        },
        async setDetailsDataToList({ commit }, data) {
          let requestParam = {
            ...defaultRequestParam(`${resource}/${data}`),
            data: { USERID: getUserId(), ...getUserCountry(), CUSTOMER: getCustomerId(), FISCAL_CODE: getCustomerId(), TOKEN: getToken() },
            method: 'GET',
          };

          let response;
          try {
            response = await Request(requestParam);
            commit(DETAILS_DATA_TO_LIST, {
              data: response.data[detailsListKey],
              request: requestParam,
            });
          } catch (error) {
            response = error;
          }
          return response;
        },
        async setStatusDataToList({ commit }) {
          let requestParam = {
            ...defaultRequestParam(`venusa/order_status`),
            data: { USERID: getUserId(), ...getUserCountry(), CUSTOMER: getCustomerId(), FISCAL_CODE: getCustomerId(), TOKEN: getToken() },
            method: 'GET',
          };

          let response;
          try {
            response = await Request(requestParam);
            commit('setStatusData', {
              data: response.data?.status,
              request: requestParam,
            });
          } catch (error) {
            response = error;
          }
          return response;
        },
        clearState({ commit }) {
          commit(CLEAR_STATE);
        },
      },
    },
  };
};
